import { Skeleton, Stack } from '@mui/material';
import AgentChatsSections from './AgentChatsSections';
import AgentSearchResults from './AgentSearchResults';
import useAgentsChats from './useAgentsChats';
import { useSelector } from 'react-redux';
import {
  selectChatsListIsLoading,
  selectSearchIsLoading,
  selectSearchResults,
  selectSearchText,
} from './agentsChatsReducer';
import { colors } from '@sweep-io/sweep-design';

const AgentChatsHistory = () => {
  const { activeChat, setActiveChatClickHandler, chats } = useAgentsChats();
  const isLoadingSearch = useSelector(selectSearchIsLoading);
  const searchResults = useSelector(selectSearchResults);
  const searchText = useSelector(selectSearchText);
  const chatsListIsLoading = useSelector(selectChatsListIsLoading);
  const showSearchResults = isLoadingSearch || searchResults;

  return (
    <Stack
      sx={{
        height: '100%',
        // Target all scrollbar elements including Virtuoso's
        '& *::-webkit-scrollbar-track': {
          backgroundColor: colors.grey[100],
          background: colors.grey[100],
        },
      }}
    >
      <Stack
        sx={{
          height: '100%',
          gap: '16px',
        }}
      >
        {chatsListIsLoading && (
          <>
            <ChatItemSkeleton />
            <ChatItemSkeleton />
          </>
        )}
        {!chatsListIsLoading && (
          <>
            {showSearchResults && (
              <AgentSearchResults
                isLoadingSearch={!!isLoadingSearch}
                searchResults={searchResults}
                searchText={searchText}
                activeChatId={activeChat?.data?.id}
                onSelectActiveChat={setActiveChatClickHandler}
              />
            )}
            {!showSearchResults && (
              <AgentChatsSections
                activeChatId={activeChat?.data?.id}
                onSelectActiveChat={setActiveChatClickHandler}
                chats={chats}
              />
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
};

const ChatItemSkeleton = () => (
  <Skeleton
    variant="rectangular"
    color="red"
    animation="wave"
    width="100%"
    height="24px"
    sx={{
      borderRadius: '4px',
      backgroundColor: 'rgba(222, 223, 224, 0.24)', //same as the "search" input
      '&::after': {
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)', // shimmer
      },
    }}
  />
);

export default AgentChatsHistory;
